import React, { useEffect, useState } from 'react';
import logo from '../../../assets/owlbot_logo_login.png';
import { useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer/Footer';
import { flashBarTheme } from '../../../config/flashBar';
import axios from 'axios';
import { errorMessage } from '../../../config/errorsMsg';
import ActivityIndicator from '../../../components/ActivityIndicator/ActivityIndicator';
import FlashBar from '../../../components/FlashBar/FlashBar';
import { errorMessageAutoCapitalize } from '../../../config/helpers';
import { successMessage } from '../../../config/keyword';

const ResetPassword = () => {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const resetToken = queryParameters.get('resetToken');
  const userId = queryParameters.get('userId');
  const [state, setState] = useState<any>({
    newPassword: '',
    confirmNewPassword: '',
    resetToken: resetToken,
    userId: userId,
  });
  const { newPassword, confirmNewPassword } = state;
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit === true) {
      updatePassword();
    }
  }, [formError]);

  const validation = () => {
    const error: any = {};
    if (!newPassword) {
      error.newPassword = errorMessage.emptyNewPassword;
    } else if (newPassword.length < 12 || newPassword.length > 38) {
      error.newPassword = errorMessage.passwordLength;
    }
    if (!confirmNewPassword) {
      error.confirmNewPassword = errorMessage.emptyConfirmPassword;
    } else if (newPassword !== confirmNewPassword) {
      error.confirmNewPassword = errorMessage.passwordNotMatching;
    }
    return error;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.value });
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: '' });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} required! `,
      });
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  const handleClick = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const updatePassword = async () => {
    setIsLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_BASEURL}/account/reset-password`, state)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.isSuccess === true) {
            setFlashbar({
              ...flashbar,
              isOpen: true,
              type: flashBarTheme.SUCCESS,
              message: successMessage.RESET_PASSWORD,
            });
            setTimeout(() => {
              navigate('/');
            }, 4000);
          } else {
            setFlashbar({
              ...flashbar,
              isOpen: true,
              type: flashBarTheme.ERROR,
              message: response.data.message,
            });
          }
        }
        setIsLoading(false);
      })
      .catch(() => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          type: flashBarTheme.ERROR,
          message: errorMessage.oops,
        });
        setIsLoading(false);
      });
  };

  return (
    <div>
      <FlashBar
        message={flashbar.message}
        isOpen={flashbar.isOpen}
        type={flashbar.type}
        handleClose={() => {
          setFlashbar({ ...flashbar, isOpen: false });
        }}
      />
      {isLoading ? <ActivityIndicator /> : null}
      <div className="relative flex justify-center items-center h-screen bg-slate-100">
        <div className="border w-96 h-[400px] p-8 flex flex-col justify-center shadow-lg rounded-sm bg-white">
          <img src={logo} className="w-9/12 mx-auto my-0 pb-2" />
          <h4 className="pb-3 text-center text-blue-500 font-semibold">
            Reset Password
          </h4>
          <div className="mb-1">
            <div className="font-semibold text-[#526D82] text-sm">
              Enter new password
            </div>
            <div className="my-1 flex items-center">
              <div className="h-8 w-12 bg-[#173959] flex items-center justify-center py-1 rounded-l-sm">
                <i className="fa-solid fa-key text-white relative left-[2px]"></i>
              </div>

              <input
                type={showNewPassword ? 'text' : 'password'}
                name="newPassword"
                value={newPassword}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleChange(event);
                }}
                onKeyDown={handleKeyDown}
                placeholder="New password"
                className="h-8 block w-full text-sm border text-slate-500 focus:outline-none pl-2 pr-10 rounded-sm"
              />
              <button
                type="button"
                className="ml-[-28px] mr-2 focus:outline-none"
                tabIndex={-1}
                onClick={() => setShowNewPassword((prev) => !prev)}
                aria-label={showNewPassword ? 'Hide password' : 'Show password'}
              >
                <i
                  className={`fa-solid ${
                    showNewPassword ? 'fa-eye' : 'fa-eye-slash'
                  } text-gray-500`}
                ></i>
              </button>
            </div>
            <div className="text-sm text-[red]">{formError.newPassword}</div>
          </div>
          <div className="mb-6">
            <div className="font-semibold text-[#526D82] text-sm">
              Confirm new password
            </div>
            <div className="my-1 flex items-center">
              <div className="h-8 w-12 bg-[#173959] flex items-center justify-center py-1 rounded-l-sm">
                <i className="fa-solid fa-key text-white relative left-[2px]"></i>
              </div>
              <input
                type={showConfirmNewPassword ? 'text' : 'password'}
                name="confirmNewPassword"
                value={confirmNewPassword}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleChange(event);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Confirm new password"
                className="h-8 block w-full text-sm border text-slate-500 focus:outline-none pl-2 pr-10 rounded-sm"
              />
              <button
                type="button"
                className="ml-[-28px] mr-2 focus:outline-none"
                tabIndex={-1}
                onClick={() => setShowConfirmNewPassword((prev) => !prev)}
                aria-label={
                  showConfirmNewPassword ? 'Hide password' : 'Show password'
                }
              >
                <i
                  className={`fa-solid ${
                    showConfirmNewPassword ? 'fa-eye' : 'fa-eye-slash'
                  } text-gray-500`}
                ></i>
              </button>
            </div>
            <div className="text-sm text-[red]">{formError.confirmNewPassword}</div>
          </div>
          <div
            className="h-8 bg-blue-500 rounded-sm flex items-center justify-center cursor-pointer mb-2"
            onClick={() => handleClick()}
          >
            <div className="text-white font-normal p-2">SUBMIT</div>
          </div>
          <div className="h-8 rounded-sm flex items-center justify-center cursor-pointer">
            <div
              className="text-blue-500 font-normal p-2 text-sm"
              onClick={() => navigate('/')}
            >
              Back to Login
            </div>
          </div>
        </div>
        <div className="absolute right-0 bottom-0">
          {' '}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
